module.exports = __webpack_public_path__ + "img/2f_r_fukumitsu.c3954031.jpg";